import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "-2 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM9 14a6 6 0 0 0-6 6v1h12v-1a6 6 0 0 0-6-6z",
      stroke: "#16699C",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    _createElementVNode("circle", {
      cx: "15",
      cy: "17",
      r: "5.75",
      fill: "#EFA296",
      stroke: "#fff",
      "stroke-width": "1.5"
    }),
    _createElementVNode("path", {
      d: "M13 17h4",
      stroke: "#363634",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    })
  ]))
}